var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOn1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127,
    height: 59,
    viewBox: "0 0 127 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2994",
    "data-name": "Groupe 2994",
    transform: "translate(-70 -26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(108 26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Soustraction_7",
    "data-name": "Soustraction 7",
    d: "M51,59H0V21.2L25.5,0,36.974,9.54V6.713h5.951v7.773L51,21.2V59ZM25.473,6.039,4.485,23.147V55.226H46.454V23.147L25.473,6.039Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2-2",
    "data-name": "Group 2",
    transform: "translate(70 42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M0,43V15.449L19,0l8.55,6.952V4.892h4.433v5.665L38,15.449V43Z",
    transform: "translate(0 0)",
    fill: "#e1f4fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2",
    "data-name": "Path 2",
    transform: "translate(2.454 3.49)",
    fill: "#e1f4fb",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.29750442504883 36.7789192199707 L 0.7500041127204895 36.7789192199707 L 0.7500041127204895 13.42015266418457 L 16.02687454223633 0.9676737785339355 L 31.29750442504883 13.42006969451904 L 31.29750442504883 36.7789192199707 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16.02678489685059 1.935337066650391 L 1.500003814697266 13.77640533447266 L 1.500003814697266 36.0289192199707 L 30.54750442504883 36.0289192199707 L 30.54750442504883 13.77622222900391 L 16.02678489685059 1.935337066650391 M 16.02697372436523 0 L 32.04750442504883 13.06389999389648 L 32.04750442504883 37.5289192199707 L 3.814697265625e-06 37.5289192199707 L 3.814697265625e-06 13.06389999389648 L 16.02697372436523 0 Z",
    stroke: "none",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2-3",
    "data-name": "Group 2",
    transform: "translate(159 42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-2",
    "data-name": "Combined Shape",
    d: "M0,43V15.449L19,0l8.55,6.952V4.892h4.433v5.665L38,15.449V43Z",
    transform: "translate(0 0)",
    fill: "#e1f4fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2-2",
    "data-name": "Path 2",
    transform: "translate(2.454 3.49)",
    fill: "#e1f4fb",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.29750442504883 36.7789192199707 L 0.7500041127204895 36.7789192199707 L 0.7500041127204895 13.42015266418457 L 16.02687454223633 0.9676737785339355 L 31.29750442504883 13.42006969451904 L 31.29750442504883 36.7789192199707 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16.02678489685059 1.935337066650391 L 1.500003814697266 13.77640533447266 L 1.500003814697266 36.0289192199707 L 30.54750442504883 36.0289192199707 L 30.54750442504883 13.77622222900391 L 16.02678489685059 1.935337066650391 M 16.02697372436523 0 L 32.04750442504883 13.06389999389648 L 32.04750442504883 37.5289192199707 L 3.814697265625e-06 37.5289192199707 L 3.814697265625e-06 13.06389999389648 L 16.02697372436523 0 Z",
    stroke: "none",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOn1);
export default __webpack_public_path__ + "static/media/on__1_.b436ef9b80ae2e0fd07e83d1d3f7abc8.svg";
export { ForwardRef as ReactComponent };